const SMALL_WORDS = new Set(['a', 'an', 'and', 'as', 'at', 'but', 'by', 'for', 'in', 'of', 'on', 'or', 'the', 'to', 'vs', 'via']);
const SPECIAL_TOKENS = {
  pvt: 'Pvt',
  ltd: 'Ltd',
  llp: 'LLP',
  llc: 'LLC',
  inc: 'Inc',
  plc: 'Plc',
  co: 'Co',
  ipo: 'IPO',
  ceo: 'CEO',
  cfo: 'CFO',
  md: 'MD',
  gm: 'GM',
  avp: 'AVP',
  vp: 'VP',
  hr: 'HR',
  it: 'IT',
};

function formatToken(part, isFirstWord) {
  if (!part) return part;
  const lower = part.toLowerCase();
  if (!isFirstWord && SMALL_WORDS.has(lower)) return lower;
  if (SPECIAL_TOKENS[lower]) return SPECIAL_TOKENS[lower];
  if (lower.startsWith('mc') && lower.length > 2) {
    return 'Mc' + lower.charAt(2).toUpperCase() + lower.slice(3);
  }
  if (lower.startsWith('mac') && lower.length > 4 && /^mac[a-z]/.test(lower)) {
    return 'Mac' + lower.charAt(3).toUpperCase() + lower.slice(4);
  }
  if (part.length <= 1) return part.toUpperCase();
  return lower.charAt(0).toUpperCase() + lower.slice(1);
}

export function formatProperName(input) {
  if (input == null || typeof input !== 'string') return input;
  const cleaned = input.trim().replace(/\s+/g, ' ');
  if (!cleaned) return cleaned;

  return cleaned.split(/\s+/).map((word, wordIndex) =>
    word.split(/([-'])/).map(part => {
      if (part === '-' || part === "'") return part;
      return formatToken(part, wordIndex === 0);
    }).join('')
  ).join(' ');
}

export function normalizeSpocFields(data = {}) {
  return {
    ...data,
    ...(data.name?.trim?.() ? { name: formatProperName(data.name) } : {}),
    ...(data.designation?.trim?.() ? { designation: formatProperName(data.designation) } : {}),
  };
}
